import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import "amfe-flexible/index"

// 确保在使用前完整引入 Element UI
Vue.use(ElementUI, {
  size: 'small'  // 设置组件默认尺寸
})

// 全局修改默认配置，点击空白处不能关闭弹窗
Vue.prototype.$ELEMENT = {
  size: 'small',
  zIndex: 3000,
  dialogCloseOnClickModal: false
}

// 确保 Message 组件在全局可用
window.Vue = Vue;
window.$message = Vue.prototype.$message;

Vue.config.productionTip = false

// 解决重复点击导航路由报错
const originalPush = router.push;
const originalReplace = router.replace;

router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

router.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

//添加全局前置导航守卫
router.beforeEach((to, from, next) => {
    //如果跳转wxPay页面和wxBefore.vue,不拦截
    if (to.name == 'wxPay' || to.name == 'wxPayBefore' ||to.name == 'login') {
        console.log('to.name', to.name)
        next()
    } else {    //判断token是否存在
        const token = localStorage.getItem('token')
        console.log("token",token)
        //token不存在 为登陆 跳转登陆页面
        if(!token && to.name !== 'login'){
            next({name:'login'})
        } else if (token && to.name === 'login') {
            //token存在 为登陆 跳转登陆页面
                next({name:'home'})
            }else{
                next()
            }
    }
})

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
       store.commit('addMenu', router)
   }
}).$mount('#app')
